import { useTranslation } from 'react-i18next';

import { Button, Label, LABEL_TYPE } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { ModalLayout } from '@/components/layouts';

type OfflineBlockedPopupProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const OfflineBlockedPopup = ({ isOpen, onClose }: OfflineBlockedPopupProps) => {
  const [t] = useTranslation('common');

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className='inline-flex size-full flex-col items-center justify-center gap-y-4 px-4'>
        <Label
          text={t('offlineMode')}
          type={LABEL_TYPE.H4}
          className='text-primary-blue'
        />
        <Label
          text={t('offlinePageRestricted')}
          type={LABEL_TYPE.PARAGRAPH2}
          className='text-center text-secondary-steel-blue'
        />
        <Button
          type='button'
          variant={ButtonVariant.PRIMARY}
          handleOnClick={onClose}
          className='mb-6 w-32'>
          {t('ok')}
        </Button>
      </div>
    </ModalLayout>
  );
};
